import React from 'react';
import PropTypes from 'prop-types';

import TooltipStyled from '../styled';
import { Link } from '@ontruck/orc';
import { t, enhance } from '../utils';

const CopyableLink = ({ text, copied, weight = '', handleClick }) => {
  return (
    (copied && (
      <TooltipStyled skin={'dark'} position="top" component={t.copied} alwaysVisible={copied}>
        <Link text={text} onClick={handleClick} weight={weight} />
      </TooltipStyled>
    )) || <Link text={text} onClick={handleClick} weight={weight} />
  );
};

CopyableLink.propTypes = {
  text: PropTypes.string,
  copied: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default enhance(CopyableLink);
